import React from 'react';
import { MessageCircle, Star } from 'lucide-react';
interface ReviewProps {
  name: string;
  text: string;
  image: string;
}
const reviews: ReviewProps[] = [{
  name: 'Laura G.',
  text: 'Recuperé la movilidad del hombro. Ya no me arrastra por la calle. Es como magia, pero es ciencia.',
  image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=faces'
}, {
  name: 'Miguel A.',
  text: 'Logramos silencio total cuando llegan visitas. Antes era un caos de ladridos, ahora va a su cama.',
  image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=150&h=150&fit=crop&crop=faces'
}, {
  name: 'Patricia R.',
  text: 'Ustedes me dieron las herramientas que 3 entrenadores anteriores no pudieron. Infinitas gracias.',
  image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop&crop=faces'
}];
export function SecondProofStrip() {
  return <section className="py-10 bg-white border-t border-gray-100" data-id="element-117">
      <div className="max-w-5xl mx-auto px-4" data-id="element-118">
        <div className="text-center mb-8" data-id="element-119">
          <h3 className="text-2xl font-bold font-serif text-gray-900" data-id="element-120">
            La Comunidad DOG-CALM
          </h3>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-121">
          {reviews.map((r, idx) => <div key={idx} className="bg-cloud-grey p-6 rounded-[20px] relative shadow-sm" data-id="element-122">
              <MessageCircle className="absolute top-4 right-4 w-6 h-6 text-gray-200" data-id="element-123" />
              <div className="flex items-center gap-3 mb-4" data-id="element-124">
                <img src={r.image} alt={r.name} className="w-12 h-12 rounded-full object-cover" data-id="element-125" />
                <div data-id="element-126">
                  <p className="font-bold text-gray-900 text-sm" data-id="element-127">{r.name}</p>
                  <div className="flex mt-1" data-id="element-128">
                    {[...Array(5)].map((_, i) => <Star key={i} className="w-3 h-3 text-brand-gold fill-brand-gold" data-id="element-129" />)}
                  </div>
                </div>
              </div>
              <p className="text-gray-700 text-sm leading-relaxed" data-id="element-130">
                "{r.text}"
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}